import React from "react";
import InSeason from "./InSeason";

const Recipes = () => {
  return (
    <div>
      <InSeason />
    </div>
  );
};

export default Recipes;
